/*global _ */
import {
  name,
  mixins,
  props,
  data,
  defaultFormFields,
  validationsRules,
  defaultSections,
  EventBus,
} from './config'

export default {
  name,
  props,
  mixins,
  data() {
    return {
      ...data,
      fields: {
        reloadType: this.type || null,
        cardType: null,
        terms: false,

        card: this.card || null,
        number: this.number || null,
        product: this.product || null,

        cvv: null,
        quantity: 1,
      },
      loginEventSpace: 'reload.login',
    }
  },

  watch: {
    'fields.product'(val) {
      this.selectedProduct = this.proposalCards.find(x => (1 * x.id) === (1 * val))
      this.$$debugLog({selectedProduct: this.selectedProduct})
      EventBus.$emit('card.reload.select-product', this.selectedProduct)
    },
    'fields.reloadType'(val) {
      this.fields.card = this.card
      this.fields.number = this.number
      this.fields.product = this.product
    },
    errorMessage(val) {
      if (val) {
        this.isAddingToCart = false
      }
    },
    isSuccess() {
      this.isAddingToCart = false
    }
  },

  computed: {
    showForm() {
      return (this.onlyAuthUser && this.authenticated) || this.guestSeesDisabledForm
    },
    showFormDisabled() {
      return this.showForm && !this.authenticated && this.guestSeesDisabledForm
    },
    disabledFormClass() {
      return [{
        disabled: this.showFormDisabled
      }];
    },
    reloadTypes() {
      return this.reloadProductTypes || {}
    },
    hasMultiTypes() {
      return _.size(this.reloadTypes || {}) > 0
    },
    showReloadTypeSelector() {
      return this.hasMultiTypes && this.showTypeSelector
    },
    showReloadTypeSelectorOnTop() {
      return this.showReloadTypeSelector && this.showTypesAboveNotice
    },
    showReloadTypeSelectorOnBottom() {
      return this.showReloadTypeSelector && !this.showTypesAboveNotice
    },
    reloadTypeOptions() {
      const lang = this.reloadProductTypeLang || {}
      return _.mapValues(this.reloadTypes, (item, key) => {
        item.label = _.get(lang, `${key}.label`, item.label || _.startCase(key))
        return item
      })
    },
    userCards() {
      return this.cards || this.allCards
    },
    userCardType() {
      const reloadType = this.fields.reloadType
      return _.get(this.reloadTypes, `${reloadType}.type`)
    },
    userCardsOfType() {
      const cards =  this.showTypeSelector ? _.get(this.allCardsTyped, this.userCardType, {}) : this.userCards
      return cards
    },
    showAuth () {
      return !this.authenticated && this.onlyAuthUser
    },

    hasUserCards () {
      return this.authenticated && !_.isEmpty(this.userCardsOfType)
    },
    showProductsBox() {
      return ((this.showCardCodeInput && !this.$v.fields.cvv.$invalid && !this.$v.fields.number.$invalid)
        || (!this.showCardCodeInput && !this.$v.fields.number.$invalid)) && !_.isEmpty(this.proposalCards)
    },
    proposalCards() {
      const reloadType = this.fields.reloadType
      return this.productsTyped[reloadType] || this.products || []
      // let proposal = []
      // const reloadType = this.fields.reloadType
      // if (this.authenticated && this.hasUserCards) {
      //   const card = this.selectedUserCard || {}
      //   proposal = this.productsTyped[reloadType] || this.products || []
      // } else {
      //   proposal = this.products || []
      // }
      // return proposal
    },
    showSummaryBox() {
      return this.showSummary && !_.isEmpty(this.selectedProduct)
    },
    isFormValid() {
      return !this.isAnyInvalid
    },
    disabledSubmit() {
      return this.isAnyInvalid
    },
    disabledInputs() {
      return this.showReloadTypeSelector && !this.fields.reloadType
    },

    infoTitle() {
      return this.isNumberInfo ?  this.numberInfoModalTitle : this.codeInfoModalTitle
    },
    infoHeaderText() {
      return this.isNumberInfo ? this.numberInfoModalHeader : this.codeInfoModalHeader
    },
    infoFooterText() {
      return this.isNumberInfo ? this.numberInfoModalFooter : this.codeInfoModalFooter
    },
    infoImgSrc() {
      return this.isNumberInfo ? this.numberInfoModalImgSrc : this.codeInfoModalImgSrc
    },

    selectedUserCard() {
      const id = this.fields.card
      const number = this.fields.number
      return _.find(this.userCards, c => {
        return c.id === id || c.number === number
      })
    },
    localCart() {
      const card = this.selectedProduct || {price: 0, tax: 0}
      this.$$debugLog({card})
      const quantity = this.fields.quantity || 1
      const cart = {
        subTotal: card.price * quantity,
        tax: card.tax * quantity,
        total: card.price * quantity + card.tax * quantity
      }
      this.$$debugLog({cart})
      return cart
    },
    summaryComponentName() {
      return this.summaryComponent || 're-blank-component'
    }
  },

  async created() {
    this.isAddingToCart = false
    this.setupForm(validationsRules, defaultFormFields)
    EventBus.$on('user.auth' , async (user) => {
      await this.init(user)
    })
    await this.pingUser()
    if (this.user) {
      await this.init(this.user)
    }
  },

  methods: {
    async init(user) {
      await this.loadUserCards(user || this.user)
    },
    async loadUserCards(user) {
      this.isLoadingCards = true
      const { data: { data: playcard } } = await axios.get(`${this.config.apiUri}/customer/playcard?page_size=999`)
      const { data: { data: giftcard } } = await axios.get(`${this.config.apiUri}/customer/giftcard?page_size=999`)

      const claimedGiftcards = _.filter(giftcard, card => card.state !== 'given' && !card.is_virtual)
      const claimedPlaycards = _.filter(playcard, card => !card.is_virtual)

      this.allCards = claimedPlaycards.concat(claimedGiftcards)
      this.allCardsTyped = {giftcard: claimedGiftcards, playcard: claimedPlaycards}

      this.isLoadingCards = false
      this.$nextTick(()=> {
        if (this.card) {
          this.fields.card = this.card
        }

        if (this.number) {
          this.fields.number = this.number
        }

        if (this.product) {
          this.fields.product = this.product
        }
      })

    },
    getFormExtraClasses() {
      return []
    },
    addToCart() {
      EventBus.$emit('buy.card-reload.before.add-to-cart')
      this.$v.$touch()
      this.formSubmitting = true
      if (this.isFormValid) {
        this.isAddingToCart = true
        let card = {}
        if (this.authenticated && this.hasUserCards) {
          card = this.selectedUserCard
        } else {
          card = {number: this.fields.number}
          if (this.showCardCodeInput ) {
            card.cvv = this.fields.cvv
          }
        }
        const payload = {card, product: this.selectedProduct, quantity: this.fields.quantity}
        this.addCartItem(this.getCartItem())
        this.$emit('addToCart', payload)
        EventBus.$emit('buy.card-reload.add-to-cart', payload)
        this.isSubmitting = true
      }
    },
    whatIsNumber() {
      this.showInfoModal = true
      this.isNumberInfo = true
    },
    whatIsCode() {
      this.showInfoModal = true
      this.isNumberInfo = false
    },
    closeInfoModal () {
      this.showInfoModal = false
      this.isNumberInfo = false
    },
    getSummarySection() {
      return this.parseDynamicSections(
        this.$$s('sections', defaultSections),
        {}
      )
    },
    getCartItem() {
      const card = this.selectedUserCard
      return {
        editable: this.cartItemEditable,
        type: this.fields.reloadType || 'playcard_reload',
        total: this.selectedProduct.price * (this.fields.quantity  || 1),
        count: this.fields.quantity || 1,
        payload: {
          product_id: this.fields.product,
          options: {
            number: card.number,
          },
        },
        attributes: {
          product: this.selectedProduct,
          number: card.number,
        },
      }
    },
  }
}
